module.exports = __webpack_public_path__ + "static/media/ff-movie.1c92ed8e.png";